import { CreditSummary } from '../../models';

export const creditSummary: CreditSummary = {
  statementCredit: '-$200.00',
  statementCreditLabel: 'AMEX Statement Credit*',
  totalLabel: 'Total After Statement Credit',
  total: {
    multiUnit: false,
    cash: {
      value: '80',
      fraction: '.00',
      symbol: '$',
      code: 'USD'
    },
    miles: {
      value: 0,
      code: 'USD'
    }
  }
};
